import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import { StatusType } from '../order.types';
import { requiredSignatureStatusesByAutoGeneration } from './utils/finishOrderContractNotice.utils';

const useFinishOrderContractNotice = (orderStatus?: StatusType) => {
  const autoContractGeneration = useGeneralSettingsStore(
    (state) => state.generalSettings.autoContractGeneration,
  );

  const shouldShowAutoContractNotice =
    !!autoContractGeneration &&
    !!orderStatus &&
    requiredSignatureStatusesByAutoGeneration[autoContractGeneration].includes(orderStatus);

  return { shouldShowAutoContractNotice };
};

export default useFinishOrderContractNotice;
